import type { FamilyCustodyShare } from '@/types';

export function buildFamilyCustodyScopeFilter(userId: string, shareId: string | null) {
  if (!shareId) {
    return `user_id.eq.${userId}`;
  }

  return `share_id.eq.${shareId},and(user_id.eq.${userId},share_id.is.null)`;
}

export function mapFamilyCustodyShareRow(row: any): FamilyCustodyShare | null {
  if (!row) return null;

  return {
    id: row.id,
    inviteCode: row.invite_code,
    ownerUserId: row.owner_user_id,
    ownerDisplayName: row.owner_display_name || 'Parent',
    memberUserId: row.member_user_id || null,
    memberDisplayName: row.member_display_name || null,
    status: row.status === 'active' ? 'active' : 'invited',
    createdAt: row.created_at,
  };
}

export function familyCustodyActorLabel(
  share: FamilyCustodyShare | null,
  currentUserId: string | null,
  actorUserId: string | null,
) {
  if (!actorUserId) {
    return 'Added in the shared trail';
  }

  if (currentUserId && actorUserId === currentUserId) {
    return 'Added by you';
  }

  if (!share) {
    return 'Added by the other parent';
  }

  if (share.ownerUserId === actorUserId) {
    return `Added by ${share.ownerDisplayName || 'the other parent'}`;
  }

  if (share.memberUserId === actorUserId) {
    return `Added by ${share.memberDisplayName || 'the other parent'}`;
  }

  return 'Added in the shared trail';
}
